import Helper from '@ember/component/helper';
import { service } from '@ember/service';
import type UserFeatureFlagsService from 'garaje/services/user-feature-flags';

export interface UserFeatureEnabledSignature {
  Args: {
    Positional: [featureName: string];
  };
  Return: boolean;
}

/**
 * This UserFeatureEnabled helper determines if a feature is on or off for a user.
 * Handy for template only components when you don't want to create a component.js when all you need is the featureFlags service :)
 *
 * Example usage:
 * <input readonly={{user-feature-enabled "your-feature"}} ... >
 */
export default class UserFeatureEnabled extends Helper<UserFeatureEnabledSignature> {
  @service declare userFeatureFlags: UserFeatureFlagsService;

  compute([feature]: UserFeatureEnabledSignature['Args']['Positional']): UserFeatureEnabledSignature['Return'] {
    return this.userFeatureFlags.isEnabled(feature);
  }
}
